import { render, staticRenderFns } from "./RegistrationBillDialog.vue?vue&type=template&id=473f692c&"
import script from "./RegistrationBillDialog.vue?vue&type=script&lang=js&"
export * from "./RegistrationBillDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSeparator,QBadge,QPagination,QTable,QInnerLoading,QTr,QTh,QTd,QBtn,QCardActions,QField,QInput,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSeparator,QBadge,QPagination,QTable,QInnerLoading,QTr,QTh,QTd,QBtn,QCardActions,QField,QInput})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
